<template>
  <el-card class="h-full system-config-detail" :body-style="{ height: '100%' }">
    <div class="clear-both flex items-center">
      <el-button
        type="primary"
        size="small"
        class="mr-10px"
        @click="backup"
        v-if="queryMode === 'read'"
        >返回</el-button
      >
      <span class="border-l-3 border-color-primary pl-10px text-18px">{{ typeName }}</span>
    </div>
    <el-form
      label-width="150px"
      ref="form"
      :model="form"
      :rules="formRules"
      :disabled="queryMode === 'read'"
      class="mt-20px h-[calc(100%-100px)]"
      v-loading="formLoading"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="配置名称" prop="name">
            <el-input
              v-model="form.name"
              size="small"
              clearable
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="系统名称" prop="systemName">
            <el-input
              v-model="form.systemName"
              size="small"
              clearable
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="门户logo" prop="logo">
            <el-upload
              action=""
              :before-upload="beforeUpload"
              :http-request="imgUpload"
              drag
              class="logo-uploader"
              :show-file-list="false"
              :disabled="queryMode === 'read'"
            >
              <el-image
                :src="`${fileUrl}${form.logo}`"
                v-if="form.logo"
                fit="contain"
                class="w-full h-full"
              ></el-image>
              <div class="w-full h-full flex justify-center items-center">
                <span class="iconfont icon-line-add text-color-secondary"></span>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="系统主题">
            <el-radio-group v-model="form.themed">
              <el-radio label="">
                无主题
              </el-radio>
              <el-radio label="newYear">
                新春主题
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="首页置灰" prop="homeAsh">
        <el-switch v-model="form.homeAsh"></el-switch>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="配置启用" prop="isEnable">
            <el-switch v-model="form.isEnable"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="!form.isEnable">
          <el-form-item label="定时启用" prop="timedEnable">
            <el-switch v-model="form.timedEnable"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="form.timedEnable && !form.isEnable">
          <el-form-item label="启用时间" prop="startTime">
            <el-date-picker
              v-model="form.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="启用时间"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() < Date.now() - 8.46e7 //如果没有后面的-8.64e6就是不可以选择今天的
                },
                selectableRange: startTimeRange,
              }"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="text-center mt-20px" v-if="queryMode !== 'read'">
      <el-button
        type="primary"
        size="medium"
        class="iconfont icon-save"
        @click="save"
        :loading="saveLoading"
        >保存</el-button
      >
      <el-button size="small" class="ml-20px" @click="backup">取消</el-button>
    </div>
  </el-card>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import { SystemSettingApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'

const fileApi = new FileApi()
const systemSettingApi = new SystemSettingApi()

export default {
  name: 'systemConfigDetail',
  data() {
    return {
      form: {
        name: '',
        systemName: '',
        logo: '',
        homeAsh: false,
        isEnable: false,
        timedEnable: false,
        startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        themed: '',
      },
      formRules: {
        name: [{ required: true, message: '请输入配置名称', trigger: 'blur' }],
        systemName: [{ required: true, message: '请输入系统名称', trigger: 'blur' }],
        logo: [{ required: true, message: '请上传门户logo', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择启用时间', trigger: 'change' }],
      },
      saveLoading: false,
      formLoading: false,
      startTimeRange: '',
    }
  },
  computed: {
    queryMode() {
      return this.$route.query.type
    },
    typeName() {
      const typeData = {
        create: '新增系统设置',
        update: '编辑系统设置',
        read: '系统设置详情',
      }
      return typeData[this.queryMode]
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    'form.startTime': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const nowDate = dayjs().format('YYYY-MM-DD HH:mm:ss')
          const date = dayjs(newValue).format('YYYY-MM-DD HH:mm:ss')
          const dt = nowDate.split(' ')
          let st = ''
          if (date.split(' ')[0] === dt[0]) {
            // 是今天,选择 的时间开始为此刻的时分秒
            st = dt[1]
          } else {
            // 明天及以后从0时开始
            st = '00:00:00'
          }
          this.startTimeRange = [`${st} - 23:59:59`]
        }
      },
    },
  },
  methods: {
    beforeUpload(file) {
      if (
        !['jpg', 'jpeg', 'png'].includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
      ) {
        this.$message.warning('请上传图片格式文件')
        return false
      }
      return true
    },
    async imgUpload(params) {
      const [err, res] = await fileApi.upload({
        files: [params.file],
        authLevel: 2,
      })
      if (!err) {
        this.form.logo = res?.[0].id
        this.$refs.form.clearValidate('logo')
      }
    },
    backup() {
      this.$router.push(`${this.routerBase}/portal-management/system-management/system-config`)
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            body: {
              systemColor: '',
              ...this.form,
              startTime: this.form.startTime === 'Invalid Date' ? null : this.form.startTime,
            },
          }
          if (this.queryMode === 'create') {
            const [err, res] = await systemSettingApi.addSystemSetting(params)
            if (!err) {
              this.$message.success('新增成功')
              this.backup()
            }
          } else if (this.queryMode === 'update') {
            const [err, res] = await systemSettingApi.updateSystemSetting(params)
            if (!err) {
              this.$message.success('编辑成功')
              this.backup()
            }
          }
        }
      })
    },
    async getDetail() {
      const id = this.$route.query.id
      if (!id) return
      this.formLoading = true
      const [err, res] = await systemSettingApi.getSystemSetting_0(id)
      if (!err) {
        this.form = res
        this.form.startTime = dayjs(this.form.startTime).format('YYYY-MM-DD HH:mm:ss')
        this.form.themed = res.themed || ''
      }
      this.formLoading = false
    },
  },
  mounted() {
    this.getDetail()
  },
}
</script>

<style lang="scss" scoped>
.system-config-detail {
  .logo-uploader {
    ::v-deep .el-upload-dragger {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
